import type * as ents from '@attain-apps/entities'
import * as store from '@attain-apps/fe/web/main/lib/store'

import { State } from './state'

/**
 * Core actions for the records bulk functional usage workflow.
 */
// NOTE: intentionally missing return type so that type can be inferred
export function getActionsConfig() {
  return {
    /** Opens the bulk functional usage modal for the current selection */
    initiate: store.actions.standalone({
      data: store.actions.Data.NONE,
      reducer: () => State.onInitiate(),
    }),
    /** Closes the bulk functional usage modal without applying anything */
    cancel: store.actions.standalone({
      data: store.actions.Data.NONE,
      reducer: () => State.INITIAL,
    }),
    /** Stores the methodology being applied */
    setMethodology: store.actions.standalone({
      data: store.actions.Data.asIs<ents.extra.space.Record.FunctionalUsage.Methodology>(),
      reducer: ({ state, data: methodology }) =>
        State.onSetMethodology(methodology, state),
    }),
    /** Stores the service center whose allocations will be applied */
    setServiceCenter: store.actions.standalone({
      data: store.actions.Data.asIs<
        ents.extra.space.ServiceCenter.Id | undefined
      >(),
      reducer: ({ state, data: serviceCenterId }) =>
        State.onSetServiceCenter(serviceCenterId, state),
    }),
    /** Stores one edited allocation */
    updateFunctionalization: store.actions.standalone({
      data: store.actions.Data.asIs<ents.extra.space.Functionalization>(),
      reducer: ({ state, data: functionalization }) =>
        State.onUpdateFunctionalization(functionalization, state),
    }),
    /**
     * Applies the edited functional usage to every selected record.
     *
     * Cancelled by its effect when there is nothing to apply it to.
     */
    submit: store.actions.request({
      input: store.actions.Data.NONE,
      output: store.actions.Data.NONE,
      reducers: {
        request: ({ state }) => State.onRequest(state),
        success: () => State.INITIAL,
        error: ({ state, data: { error } }) => State.onError(error, state),
        cancellation: ({ state }) => State.onCancellation(state),
      },
    }),
  } as const satisfies store.actions.Config.Constraint<State>
}
